import React, { useMemo } from 'react';
import { NetworkFilteredEmptyProps } from './types';
import { NetworkBase } from '../network-base/network-base';
import { AllSearch } from '@vtbhome/juicyfront/indexIcon';
import { IconNoFilesFound } from '@shared/icon/icon-no-files-found/icon-no-files-found';

export const NetworkFilteredEmpty: React.FC<NetworkFilteredEmptyProps> = ({
    title = 'Ничего не найдено',
    description = `Попробуйте скорректировать\nпараметры запроса`,
    size,
    ...props
}) => {
    const Icon = useMemo(() => {
        switch (size) {
            case 'l': {
                return IconNoFilesFound;
            }
            case 's': {
                return AllSearch;
            }
        }
    }, [size]);
    return <NetworkBase Icon={<Icon />} size={size} title={title} description={description} {...props} />;
};
